import { useMatch } from 'react-router-dom'

/** Whether the editor shows the Planansicht (the plan view page). */
const useIsPlanView = (): boolean =>
  !!useMatch({ path: '/editor/:projectId/plan-view', end: false })

export default useIsPlanView
